import { Done } from '@mui/icons-material'
import { Modal } from 'antd'
import AutoComplete from 'react-google-autocomplete'
import { locationFormattedStringAtom } from '../../../State/Musician/locationFormattedStringAtom'
import { useAtom } from 'jotai'
import { locationGeometryAtom } from '../../../State/Musician/locationGeometryAtom'
import { locationIdAtom } from '../../../State/Musician/locationIdAtom'

const EditLocationModal = ({ isModalOpen, handleOk }: { isModalOpen: boolean; handleOk: () => void }) => {
  const [, setLocationFormattedString] = useAtom(locationFormattedStringAtom)
  const [, setLocationGeometry] = useAtom(locationGeometryAtom)
  const [locationId, setLocationId] = useAtom(locationIdAtom)

  return (
    <Modal centered open={isModalOpen} closable={false} footer={[]}>
      <div className="flex flex-col items-center">
        <AutoComplete
          className="text-input"
          apiKey={process.env.REACT_APP_MAPS_API_KEY}
          onPlaceSelected={(place) => {
            setLocationFormattedString(place.formatted_address)
            setLocationGeometry({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
            setLocationId(place.place_id)
          }}
          options={{
            types: ['(regions)'],
            componentRestrictions: { country: ['us', 'ps', 'il'] },
          }}
        />
        <button
          className="flex p-0 mt-2.5 justify-center items-center size-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
          onClick={() => (locationId ? handleOk() : null)}
        >
          <Done />
        </button>
      </div>
    </Modal>
  )
}

export default EditLocationModal
